// src/http.tsx
import axios from "axios";

const baseURL = process.env.REACT_APP_API_URL;

const http = axios.create({
  baseURL,
  withCredentials: true, // Required for cookies
});

// Authentication zelf loopt via HttpOnly-cookies; de backend leest de
// 'access_token'-cookie automatisch. Eén interceptor: als het token verlopen
// is (401) melden we dat app-breed, zodat AuthContext terug kan naar het
// loginscherm i.p.v. een "ingelogde" app waarin elke request stukloopt.
export const UNAUTHORIZED_EVENT = "koc:unauthorized";

// Het deel van een axios-fout waar de interceptors naar kijken.
type HttpFout =
  | { message?: string; code?: string; response?: { status?: number } }
  | undefined;

export const onUnauthorizedResponse = (error: HttpFout): Promise<never> => {
  if (error?.response?.status === 401) {
    window.dispatchEvent(new Event(UNAUTHORIZED_EVENT));
  }
  return Promise.reject(error);
};

// Verbindingsseintje voor de OfflineBanner: een fout zónder antwoord van de
// server betekent "verbinding weg", het eerstvolgende antwoord daarna (ook een
// foutstatus: de server was bereikbaar) "verbinding terug". Alleen bij een
// omslag vuren. Bewust afgebroken verzoeken tellen niet mee.
export const VERBINDING_EVENT = "koc:verbinding";

let verbindingOnline = true;

const meldVerbinding = (online: boolean) => {
  if (verbindingOnline === online) return;
  verbindingOnline = online;
  window.dispatchEvent(
    new CustomEvent(VERBINDING_EVENT, { detail: { online } }),
  );
};

export const onSuccesResponse = <T,>(response: T): T => {
  meldVerbinding(true);
  return response;
};

export const onFoutResponse = (error: HttpFout): Promise<never> => {
  // axios 1.x geeft elk afgebroken verzoek (ook via AbortController) als
  // CanceledError met code ERR_CANCELED.
  const afgebroken = error?.code === "ERR_CANCELED";
  if (error?.response) {
    meldVerbinding(true);
  } else if (!afgebroken) {
    meldVerbinding(false);
  }
  return onUnauthorizedResponse(error);
};

http.interceptors.response.use(onSuccesResponse, onFoutResponse);

export default http;
